// extracted by mini-css-extract-plugin
export default {"Emoji":"Emoji_Emoji__7ap+g","Item":"Emoji_Item__rPZub","Active":"Emoji_Active__Cfwpp","titleText":"Emoji_titleText__YKT9F"};